<template>
<div id="salesmanList">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="100">
      <FormItem class="form_item" :label="$t('conditionRoleName')">
        <Input  clearable size="default"  v-model="roleName" :placeholder="$t('enter')"/>
      </FormItem>
      <div class="buttonDiv">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchRoleList">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addRole">{{$t('add')}}</el-button>
      </div>
    </Form>
     <div class="contentTableDiv">
         <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
            <el-table-column prop="roleId" v-if="false"></el-table-column>
            <el-table-column prop="name" :label="$t('roleName')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="description" :label="$t('roleDescripe')" align="center"></el-table-column>
             <el-table-column :label="$t('operate')" align="center" fixed="right"  width="400">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
                <el-button size="mini" type="success" @click="roleToMenu(scope.row)">{{$t('operateRole')}}</el-button>
             </template>
          </el-table-column>
        </el-table> 
    </div>
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
         layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--新增-->
    <Modal v-model="modelAdd" :closable='false' :mask-closable='false' :title="$t('addRoleInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="add">{{$t('confrim')}}</Button>
      </div>
      <Form  ref="addRoleForm"  :label-width="150">
        <FormItem :label="$t('conditionRoleName')" prop="postDes">
          <Input  v-model="addRoleForm.roleName" size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem :label="$t('conditionDes')" prop="postDes">
          <Input v-model="addRoleForm.description" size="small" :placeholder="$t('enter')"/>
        </FormItem>
      </Form>
    </Modal>
    <!--修改--> 
    <Modal v-model="modelUpdate" :closable='false' :mask-closable='false' :title="$t('updateRoleInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="ok">{{$t('confrim')}}</Button>
      </div>
      <Form ref="updateRoleForm"  :label-width="150" >
        <FormItem :label="$t('conditionRoleName')" prop="postDes">
          <Input  v-model="updateRoleForm.roleName" disabled size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem :label="$t('conditionDes')" prop="postDes">
          <Input v-model="updateRoleForm.description" size="small" :placeholder="$t('enter')"/>
        </FormItem>
      </Form>
    </Modal>
    <!--权限控制-->
    <Modal v-model="modelRoleToMenu" :closable='true' :mask-closable='false' :title="$t('permissionSettings')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancelPerm">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="okPerm">{{$t('confrim')}}</Button>
      </div>
      <Form ref="roleMenuForm"  :label-width="100" >
        <div>
          <el-tree ref="tree" :data="menuList" show-checkbox node-key="nodeId" :default-expanded-keys="treeExpandedKeys" :props="defaultProps"></el-tree>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'role',
        created () {
          this.getRoleList();//获取角色列表
          this.getAllMenu();//获取所有菜单作为展开项
        },
        data () {
            return {
              roleId:null,
              roleName:null,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
              tableData: [],
              addRoleForm:{
                roleName:null,
                description:null
              },
              modelAdd: false,
              updateRoleForm:{
                roleName:null,
                description:null,
              },
              modelUpdate:false,
              modelRoleToMenu:false,
              defaultProps: {
                children: 'nodes',
                label: 'name',
              },
              menuList: [
                { 
                  nodeId:'',
                  name:'',
                  nodes:[]
                }
              ],
              treeExpandedKeys:[],//展开项
              roleToRightDTO:{
                halfCheckRightIds:[],
                allCheckRightIds:[]
              },
            }
        },
        methods: {
            getRoleList(){
              let url = `${this.$store.state.islhurl}getRoleList/${this.pageSize}/${this.currentPage}`
              let pm = {
                name: this.roleName, 
                delStatus: 0, 
                islhToken: sessionStorage.getItem('islhtoken')
              }
              this._post(url,pm).then(
                res =>{
                  if(res.code == 200){
                    this.tableData =res.data
                    this.totalCount = res.totalNums
                  }else{
                    this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res.message
                      });
                  }
                  
                }
              )
            },
            searchRoleList(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}getRoleList/${this.pageSize}/${this.currentPage}`
              let pm = {
                name: this.roleName, 
                delStatus: 0, 
                islhToken: sessionStorage.getItem('islhtoken')
              }
              this._post(url,pm).then(
                res =>{
                  if(res.code == 200){
                    this.tableData =res.data
                    this.totalCount = res.totalNums
                  }else{
                    this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res.message
                      });
                  }
                }
              )
            },
            getAllMenu(){
              let url = `${this.$store.state.islhurl}getAllMenu`             
              this._get(url).then(
                res => {      
                  this.treeExpandedKeys = res;
                  // console.log(res);
                }
              )
            },
            addRole(){
              this.addRoleForm.roleName = null;
              this.addRoleForm.description = null;
              this.modelAdd = true
            },
            add(){
              if(this.addRoleForm.roleName === null || this.addRoleForm.roleName === ''){
                var msg = this.$t('roleNameNull');
                this.$Message.error(msg);
                return;
              }
              if(this.addRoleForm.description === null || this.addRoleForm.description ===''){
                var msg = this.$t('roleDesNull');
                this.$Message.error(msg);
                return;
              }
              let params = {
                name: this.addRoleForm.roleName,
                description : this.addRoleForm.description,
              }
              let url = `${this.$store.state.islhurl}addRole`
              this._post(url,params).then(
                res => {
                  this.modelAdd = false;
                  this.getRoleList()
                  var msg = this.$t('saveSus');
                  this.$Message.success(msg);
                }
              )
            },
            handleEdit(index) {
              this.roleId = index.roleId
              this.updateRoleForm.roleName = index.name
              this.updateRoleForm.description = index.description
              this.modelUpdate = true;
            },
            //修改Role信息确认
            ok(){
              if(this.updateRoleForm.roleName === null || this.updateRoleForm.roleName === ''){
                var msg = this.$t('roleNameNull');
                this.$Message.error(msg);
                return
              }
              if(this.updateRoleForm.description === null || this.updateRoleForm.description ===''){
                var msg = this.$t('roleDesNull');
                this.$Message.error(msg);
                return
              }
              let params = {
                roleId: this.roleId,
                name : this.updateRoleForm.roleName,
                description: this.updateRoleForm.description,
              }
              let url = `${this.$store.state.islhurl}updateRole`
              this._post(url,params).then(
                res => {
                  this.modelUpdate = false;
                  this.getRoleList();
                  var msg = this.$t('modifySus');
                  this.$Message.success(msg);
                }
              )   
            },
            //权限控制
            roleToMenu(index){
              this.roleId = index.roleId
              this.getMenuByServer();
              this.getRolePermission(index.roleId);
              this.modelRoleToMenu = true;
            },
            getMenuByServer(){
              let url = `${this.$store.state.islhurl}getAllMenuAndButton`
              this._get(url).then(
                res =>{
                  this.menuList = res.menus;
                }
              )
            },
            getRolePermission(val){
              let url = `${this.$store.state.islhurl}getRolePermissionByRoleId?roleId=${val}`             
              // let ac = [7,18,19,21,22,24,25,27,9,17,12,15,10,11,32,33,16,20,30];
              // this.$refs.tree.setCheckedKeys(ac)
              this._post(url).then(
                res => {
                  this.$refs.tree.setCheckedKeys(res);
                }
              )
            },
            okPerm(){
              // console.log("半选中节点"+this.$refs.tree.getHalfCheckedKeys());
              // console.log("全选中节点"+this.$refs.tree.getCheckedKeys());
              let params = {
                halfCheckRightIds : this.$refs.tree.getHalfCheckedKeys(),
                allCheckRightIds : this.$refs.tree.getCheckedKeys(),
                roleId: this.roleId
              }
              let url = `${this.$store.state.islhurl}addRoleToRight`             
              this._post(url,params).then(
                res => {
                  this.modelRoleToMenu = false;
                  var msg = this.$t('modifySus');
                  this.$Message.success(msg);
                }
              )
            },
            //权限控制结束=====
            handleDelete(index){
              var msg1 = this.$t('delMsg');
              var msg2 = this.$t('warnMsg');
              var msg3 = this.$t('confrim');
              var msg4 = this.$t('cancle');
              this.$confirm(msg1, msg2, {
                confirmButtonText: msg3,
                cancelButtonText: msg4,
                type: 'warning'
              }).then(() => {
                let url = `${this.$store.state.islhurl}delRole?roleId=${index.roleId}`
                this._post(url).then(
                  res =>{
                    var msg = this.$t('delSus');
                    this.$Message.success(msg);
                    this.getRoleList();
                  }
                )
              }).catch(() => {
              }); 
            },
            cancelPerm(){
              this.modelRoleToMenu = false;
            },
            cancel(){
              this.modelAdd = false;
              this.modelUpdate = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getRoleList();
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getRoleList();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/sysdata/roleInfo.vue